const observer = (threshold = 1) => new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("fade-up");
        observer().unobserve(entry.target);
      }
    });
  },
  { threshold }
);

export default observer;
